import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaiinternatinalairportcab() {



    const cardData = {

keyword: "Navi Mumbai International Airport Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Navi Mumbai International Airport Cab services for airport transfers, corporate travel, hotel pickups, local commuting, and outstation journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, flight tracking support, transparent pricing, instant booking confirmation, and doorstep pickup and drop services across Navi Mumbai and nearby regions, we ensure a smooth, comfortable, and hassle-free travel experience to and from Navi Mumbai International Airport.",

topPlaces: [
    {
        title: "Panvel Junction",
        description:
            "Panvel Junction is a major railway and road connectivity hub near Navi Mumbai International Airport, linking Mumbai, Pune, and Konkan routes."
    },
    {
        title: "Ulwe Node",
        description:
            "Ulwe is a rapidly developing residential and commercial zone located close to Navi Mumbai International Airport and is expected to grow as a key travel hub."
    },
    {
        title: "Dronagiri",
        description:
            "Dronagiri is an emerging residential and logistics hub near the airport, known for its planned infrastructure and connectivity projects."
    },
    {
        title: "Belapur CBD",
        description:
            "CBD Belapur is a major business and administrative hub in Navi Mumbai with corporate offices, government buildings, and strong transport links."
    },
    {
        title: "Seawoods Grand Central",
        description:
            "Seawoods Grand Central is a modern shopping and lifestyle destination with malls, restaurants, and entertainment facilities in Navi Mumbai."
    },
    {
        title: "Kharghar Hills",
        description:
            "Kharghar Hills offer scenic viewpoints, trekking trails, and natural landscapes, making it a popular leisure spot near the airport region."
    },
    {
        title: "Nerul Sector Area",
        description:
            "Nerul is a well-developed residential locality in Navi Mumbai known for connectivity, markets, and frequent airport cab usage."
    },
    {
        title: "Taloja MIDC",
        description:
            "Taloja MIDC is a major industrial zone near Navi Mumbai International Airport, frequently used for corporate and business travel."
    },
    {
        title: "Uran Coastal Belt",
        description:
            "Uran is a coastal region near the airport known for ports, beaches, and scenic surroundings, adding value to regional connectivity."
    },
    {
        title: "Palm Beach Road Corridor",
        description:
            "Palm Beach Road is a premium highway in Navi Mumbai offering smooth connectivity, scenic driving routes, and fast airport access."
    }
],



services: [
{
name: "Navi Mumbai International Airport Cab",
description: "Navi Mumbai International Airport Cab service by 1Touch Cabs offers reliable, safe, and comfortable transportation for passengers travelling to and from the upcoming Navi Mumbai International Airport. We provide a wide range of vehicles including Sedan, SUV, Innova, Innova Crysta, Ertiga, and Kia Carens with professional chauffeurs experienced in airport transfers and city-to-airport routes. Whether it is business travel, family trips, or tourist arrivals, we ensure punctual pickups, smooth driving, luggage assistance, and 24x7 availability. Our service focuses on convenience, transparency, and stress-free airport travel across Navi Mumbai and nearby regions."
},
{
name: "Navi Mumbai International Airport Taxi",
description: "Navi Mumbai International Airport Taxi service provides dependable airport transportation for arrivals and departures with clean, air-conditioned vehicles and experienced drivers. 1Touch Cabs ensures timely pickups, safe driving, and comfortable journeys for passengers travelling to hotels, homes, offices, or outstation destinations. With transparent pricing and professional service, we guarantee a smooth airport travel experience at any time of the day."
},
{
name: "Navi Mumbai International Airport Cab Service",
description: "Navi Mumbai International Airport Cab Service offers complete airport transportation solutions for individuals, families, and corporate travellers. 1Touch Cabs provides well-maintained vehicles, trained chauffeurs, and reliable service for both pickup and drop requirements. We ensure punctuality, comfort, and safety for every journey connected to the airport."
},
{
name: "Taxi Service Navi Mumbai International Airport",
description: "Taxi Service Navi Mumbai International Airport provides quick and efficient transportation for passengers needing reliable airport connectivity. 1Touch Cabs ensures professional chauffeurs, clean vehicles, and smooth rides for both local and long-distance travel. Our service is designed for maximum convenience and customer satisfaction."
},
{
name: "Book Cab Navi Mumbai International Airport",
description: "Book Cab Navi Mumbai International Airport service allows passengers to easily reserve airport taxis through a fast and simple booking process. 1Touch Cabs offers instant confirmations, flexible vehicle options, and transparent pricing for all types of travel needs. Whether for arrivals or departures, we ensure reliable airport transportation."
},
{
name: "Online Cab Booking Navi Mumbai International Airport",
description: "Online Cab Booking Navi Mumbai International Airport service provides a convenient way to book airport taxis anytime. 1Touch Cabs ensures easy booking, multiple vehicle choices, competitive pricing, and professional chauffeur service for seamless airport travel experience."
},
{
name: "Best Cab Navi Mumbai International Airport",
description: "Best Cab Navi Mumbai International Airport service by 1Touch Cabs ensures premium airport transportation with clean vehicles, experienced drivers, and punctual service. We focus on passenger comfort, safety, and reliability for both short and long-distance airport transfers."
},
{
name: "Cheapest Cab Navi Mumbai International Airport",
description: "Cheapest Cab Navi Mumbai International Airport service offers budget-friendly airport transportation without compromising safety or comfort. 1Touch Cabs provides transparent pricing, well-maintained vehicles, and reliable chauffeurs for economical airport travel."
},
{
name: "Reliable Taxi Navi Mumbai International Airport",
description: "Reliable Taxi Navi Mumbai International Airport service ensures safe, punctual, and dependable transportation for all airport passengers. 1Touch Cabs guarantees professional drivers, clean vehicles, and consistent service quality for stress-free travel."
},
{
name: "Navi Mumbai International Airport Pickup Cab",
description: "Navi Mumbai International Airport Pickup Cab service provides timely pickup solutions with flight tracking, luggage assistance, and professional chauffeurs. 1Touch Cabs ensures smooth and comfortable travel from the airport to any destination in Mumbai, Navi Mumbai, or nearby cities."
},
{
name: "Navi Mumbai International Airport Drop Cab",
description: "Navi Mumbai International Airport Drop Cab service offers punctual and reliable transportation from homes, hotels, and offices to the airport. 1Touch Cabs ensures timely arrivals, safe driving, and comfortable rides for stress-free departures."
},
{
name: "Airport Pickup and Drop Navi Mumbai International Airport",
description: "Airport Pickup and Drop Navi Mumbai International Airport service provides complete end-to-end airport transportation solutions. 1Touch Cabs ensures smooth arrivals and departures with professional chauffeurs, clean vehicles, and 24x7 availability for all passengers."
},
{
name: "Innova Cab Navi Mumbai International Airport",
description: "Innova Cab Navi Mumbai International Airport service offers spacious and comfortable transportation for families and group travellers. 1Touch Cabs provides well-maintained Innova vehicles with experienced chauffeurs for safe airport transfers and long-distance travel."
},
{
name: "Innova Crysta Cab Navi Mumbai International Airport",
description: "Innova Crysta Cab Navi Mumbai International Airport service delivers premium luxury airport transportation with extra comfort, clean interiors, and professional chauffeurs. 1Touch Cabs ensures a smooth and stress-free travel experience for families and corporate clients."
},
{
name: "Sedan Cab Navi Mumbai International Airport",
description: "Sedan Cab Navi Mumbai International Airport service provides affordable and comfortable airport transportation for individuals and small families. 1Touch Cabs offers clean, air-conditioned sedans with experienced drivers for safe and punctual travel."
}
],

tableData: [
["Navi Mumbai International Airport Cab","Navi Mumbai International Airport Taxi"],
["Navi Mumbai International Airport Cab Service","Taxi Service Navi Mumbai International Airport"],
["Book Cab Navi Mumbai International Airport","Online Cab Booking Navi Mumbai International Airport"],
["Best Cab Navi Mumbai International Airport","Cheapest Cab Navi Mumbai International Airport"],
["Reliable Taxi Navi Mumbai International Airport","Navi Mumbai International Airport Pickup Cab"],
["Navi Mumbai International Airport Drop Cab","Airport Pickup and Drop Navi Mumbai International Airport"],
["Innova Cab Navi Mumbai International Airport","Innova Crysta Cab Navi Mumbai International Airport"],
["Sedan Cab Navi Mumbai International Airport","Navi Mumbai International Airport Cab Service"]
],











whychoose: [
    {
        WhyChooseheading: "Reliable Navi Mumbai International Airport Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Navi Mumbai International Airport Cab services for airport transfers, business travel, family trips, hotel transfers, and outstation transportation requirements."
    },
    {
        WhyChooseheading: "24x7 Airport Pickup and Drop Availability",
        WhyChoosedescription: "Our airport cab services operate round the clock, allowing passengers to book convenient transportation for arrivals, departures, and connecting travel schedules."
    },
    {
        WhyChooseheading: "Perfect for Domestic and International Travelers",
        WhyChoosedescription: "Whether you are arriving from another city or an international destination, our airport transfer services ensure a comfortable and hassle-free journey."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and luggage requirements."
    },
    {
        WhyChooseheading: "Local and Outstation Airport Transfers",
        WhyChoosedescription: "Book direct airport transfers to Mumbai, Navi Mumbai, Thane, Pune, Nashik, Lonavala, Shirdi, Mahabaleshwar, Goa, Surat, Ahmedabad, and other destinations."
    },
    {
        WhyChooseheading: "Flight Monitoring and Timely Coordination",
        WhyChoosedescription: "Our team tracks flight schedules and arrival timings to ensure prompt pickups, even if your flight is delayed or rescheduled."
    },
    {
        WhyChooseheading: "Professional Drivers and Safe Transportation",
        WhyChoosedescription: "Our experienced chauffeurs ensure safe driving, punctual service, route expertise, and a comfortable travel experience throughout your journey."
    },
    {
        WhyChooseheading: "Ideal for Families, Corporate Travelers, and Groups",
        WhyChoosedescription: "From individual travelers and families to business executives and corporate teams, we provide suitable airport transportation solutions for every requirement."
    }
]
};

const faqData = [
    {
        question: "What is Navi Mumbai International Airport Cab Service?",
        answer: "Navi Mumbai International Airport Cab Service provides airport pickup and drop transportation for passengers traveling to and from Navi Mumbai International Airport."
    },
    {
        question: "Can I pre-book a cab for Navi Mumbai International Airport?",
        answer: "Yes, customers can pre-book airport cabs in advance to ensure timely pickups and smooth transportation."
    },
    {
        question: "Which vehicles are available for airport transfers?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles are available."
    },
    {
        question: "Do you provide airport pickup and drop services 24/7?",
        answer: "Yes, airport transfer services are available throughout the day and night according to customer travel schedules."
    },
    {
        question: "Can corporate travelers use this service regularly?",
        answer: "Yes, many companies and business professionals use our airport cab services for executive transportation, client pickups, and employee travel."
    },
    {
        question: "Are Tempo Travellers available for group airport transfers?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, tourists, wedding guests, and corporate teams."
    },
    {
        question: "Do drivers track flight arrival schedules?",
        answer: "Yes, flight timings are monitored to ensure timely pickups even if flights are delayed or rescheduled."
    },
    {
        question: "Can I book an airport cab for outstation destinations?",
        answer: "Yes, customers can directly travel from Navi Mumbai International Airport to Pune, Nashik, Shirdi, Mahabaleshwar, Goa, Surat, Ahmedabad, and many other locations."
    },
    {
        question: "Is advance booking recommended for airport transportation?",
        answer: "Yes, advance booking helps secure your preferred vehicle and ensures smooth airport travel arrangements."
    },
    {
        question: "How can I book a Navi Mumbai International Airport Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Kunal Shah",
        feedback:
            "My airport pickup experience was excellent. The driver arrived on time, assisted with luggage, and ensured a comfortable ride to my destination.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Priya Deshmukh",
        feedback:
            "We booked a family airport transfer and were extremely satisfied with the service. The vehicle was spacious, clean, and the entire journey was smooth and stress-free.",
        rating: 5
    }
];
























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai International Airport Cab Service",
  "image": "https://www.mumbaiairportcabs.com/assets/images/navi-mumbai-international-airport-cab.jpg",
  "description": "Book Navi Mumbai International Airport cab service for safe, reliable, and comfortable airport transfers. Mumbai Airport Cabs offers 24x7 taxi service with professional drivers, easy booking, and affordable pricing.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "4980"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/navi-mumbai-international-airport-cab"
  }
};





    return (
        <div>


<Helmet>
  <title>Navi Mumbai International Airport Cab Service | 24x7 Taxi Booking | +91 9545731161</title>

  <meta
    name="description"
    content="Book Navi Mumbai International Airport cab service for reliable airport transfers. 24x7 taxi booking with professional drivers and affordable pricing."
  />

  <meta
    name="keywords"
    content="navi mumbai international airport cab, navi mumbai international airport taxi, navi mumbai international airport cab service, taxi service navi mumbai international airport, book cab navi mumbai international airport, online cab booking navi mumbai international airport"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/19.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Navimumbaiinternatinalairportcab;